import './CartAbandoned.scss'

import {Popup, PopupClose, PopupContent} from '../../../ui/Popup'

import React from 'react'
import {Theme} from '../../../Theme'
import {WysiwygType} from 'types'
import {style} from '../../../../util/style'
import {useCart} from 'util/cart'
import {useTranslation} from 'util/i18n'

const styles = style('cartabandoned')

export type CartAbandonedType = {
	title?: string
	text?: WysiwygType
	confirm?: string
	cancel?: string
	isOpen: boolean
	onCancel: () => void
	onConfirm: () => void
}

export const CartAbandoned: React.FC<CartAbandonedType> = ({
	isOpen,
	onCancel,
	onConfirm,
	title,
	text,
	confirm,
	cancel
}) => {
	const {cart} = useCart()
	const t = useTranslation('webshop').cart.abandoned
	const countProducts = cart.quantityTotal()
	const hasProducts = countProducts > 0
	return (
		<Popup className={styles()} open={isOpen} onClose={onCancel}>
			<PopupContent mod={['greylight', 'large']}>
				<PopupClose onClose={onCancel} />
				{t.title && (
					<Theme.H4 className={styles('title')}>{title || t.title}</Theme.H4>
				)}
				{hasProducts && (
					<div className={styles('text')}>
						<Theme.Wysiwyg>
							{text?.replace(
								'{{quantity_of_items}}',
								countProducts.toString()
							) || t.text.replace('{{countProducts}}', `${countProducts}`)}
						</Theme.Wysiwyg>
					</div>
				)}
				<div className={styles('buttons')}>
					<div className={styles('buttons-item')}>
						<Theme.Button mod={['outline', 'whitebg']} onClick={onConfirm}>
							{confirm || t.btnclose}
						</Theme.Button>
					</div>
					<div className={styles('buttons-item')}>
						<Theme.Button onClick={onCancel}>
							{cancel || t.btnback}
						</Theme.Button>
					</div>
				</div>
			</PopupContent>
		</Popup>
	)
}
